
export interface IListBase {
    listadoID: number;
    departamentoGUID: string;
    UsuarioModificoGUID: string | null;
    nombre: string | null;
    departamentoNombre?: string | null;
    listadoTipo: ListType;
    listadoTipoNombre: string;
    query?: string | null;
    frecuenciaActualizacionID?: number | null;
    fechaUltimaActualizacion: string | null;
    fechaProximaActualizacion: string | null;
    listadoAtributo: IListAttribute[] | null;
    listadoDetalle?: IListDetail[] | null;
}

export interface IListAttribute {
    listadoAtributoID: number;
    listadoID: number;
    atributoGUID: string;
    usarParaFiltrarEnUsuario: boolean;
    esObligatorioUsarParaFiltrarEnUsuario: boolean;
    orden: number;
}

export interface IListDetail {
    listadoDetalleID: number;
    listadoID: number;
    codigo: string | null;
    nombre: string;
    latitud: number | null;
    longitud: number | null;
    telefono1: string | null;
    telefono2: string | null;
    telefono3: string | null;
    orden: number;
    listadoDetalleTipo: ListDetailType;
    listadoDetalleAtributo: IListDetailAttribute[] | null;    
}

export interface IListDetailAttribute {
    listadoDetalleAtributoID: number;
    listadoDetalleID: number;
    listadoAtributoID: number;
    atributoGUID: string | null;
    atributoValor: string | null;
}

export enum ListType {
    Archivo = 1,
    Query = 2
} 

export enum ListDetailType {
    Insertar = 1,
    Actualizar = 2,
    Eliminar = 3,
    NA = 4
} 